import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Sticky } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { setFilter } from '@bd/bdcore-data/build/Filters/actions';

import InsideHeader from '../../components/InsideHeader';
import PageWrapper from '../../components/PageWrapper';
import Filters from '../../components/Filters';
import HomesAlert from '../../components/HomesAlert';
import MenuFind from '../../components/MenuFind';
import AreaInfo from '../../components/AreaInfo';
import HomesResults from './HomesResults';
// import ContentSection from './ContentSection';
import AppliedFilters from '../../components/AppliedFilters';

const styles = css`
  .HomesReset_btn {
    font-size: 14px;
    font-weight: 400;
  }
  .Homes_mapSection {
    @media(max-width: 991px) {
      position: relative !important;
    }
    ${'' /* @media(min-width: 0\0) {
      position: relative !important;
    } */}
  }
  @media(min-width: 2000px) {
    .HomesList_results {
      height: auto;
    }
  }
`;

const sortOptions = [
  { title: 'Area', field: 'address.addressLocality' },
  { title: 'Price Low', field: 'price' },
  { title: 'Price High', field: 'price', dir: 'desc' },
  { title: 'SqFt Low', field: 'sqft' },
  { title: 'SqFt High', field: 'sqft', dir: 'desc' },
  { title: 'Moving Date', field: 'moveInDate' },
];

const filterOptions = [
  {
    type: 'SingleSelect',
    filter: 'Area',
    title: 'Select Area',
    placeholder: 'All Areas',
    routeParam: 'communityMarketArea',
    // onlyFilters: [],
    // saveInQueryString: true,
  },
  {
    type: 'MultiSelect',
    filter: 'Price',
    title: 'Price Range',
    placeholder: 'All',
  },
  {
    type: 'MultiSelect',
    filter: 'Beds',
    title: 'Beds',
    placeholder: 'All',
  },
  {
    type: 'MultiSelect',
    filter: 'Baths',
    title: 'Baths',
    placeholder: 'All',
  },
  {
    type: 'MultiSelect',
    filter: 'CustomSqft',
    title: 'SQ FT',
    placeholder: 'All',
  },
];

const Increment = 10;

class Homes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[4],
      viewMap: false,
      limit: Increment,
      tab: 'All',
    };

    this.setSort = this.setSort.bind(this);
  }

  setSort(sort) {
    let dir = sort.dir || 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  setShowMap = showMap => {
    this.setState({
      showMap,
    });
  }
  toggleView = () => {
    this.setState({ viewMap: !this.state.viewMap });
  }

  showMoreHomes = () => {
    this.setState({ limit: this.state.limit + Increment });
  }

  changeTabHandler = tab => {
    if (tab !== this.state.tab) {
      this.setState({ tab });
      if (tab === 'All') {
        this.props.dispatch(setFilter('IsQuick', null));
      } else {
        this.props.dispatch(setFilter('IsQuick', [{ value: tab === 'Move-In', label: tab }]));
      }
    }
  }

  render() {
    const { sort, viewMap, tab } = this.state;
    const { area, page, builder, homes } = this.props;
    const areaDescription = get(area, 'name') ? `in the ${get(area, 'name')} area` : '';
    return (
      <PageWrapper className={styles} noBlog>
        <PageHelmet
          custom
          title={`New Homes for Sale ${get(area, 'name') ? `in ${get(area, 'name')}` : ''}`}
        >
          <meta
            name="description"
            content={`Browse through new homes for sale ${areaDescription} from ${get(builder, 'name')}.`}
          />
        </PageHelmet>
        <InsideHeader
          h1={`${get(area, 'name') || ''} Available Homes`}
          background={get(page, 'page_image')}
        />
        <Sticky style={{ top: 0, zIndex: 3 }} className="Homes_mapSection">
          <div>
            <MenuFind />
            {
              homes.length === 0 &&
              <HomesAlert />
            }
            <Filters
              type="homes"
              filterOptions={filterOptions}
              clearButton={<span>Reset Filter <img src="" alt="Reset Filters Icon" /></span>}
              activeSort={sort}
              sortOptions={sortOptions}
              onSortSelect={this.setSort}
              toggleView={this.toggleView}
              viewMap={viewMap}
              tab={tab}
              changeTabHandler={this.changeTabHandler}
            />
            <div>
              <AppliedFilters
                {...this.props}
                clearButton={<span className="d-none d-md-flex flex align-items-center pr-3 HomesReset_btn">Reset Filters <img src="/images/icons/icon-refresh.svg" alt="reset filters" className="ml-2" /></span>}
                type="homes"
              />
            </div>
          </div>
        </Sticky>
        <div className="HomesList_results">
          <HomesResults
            sort={sort}
            viewMap={viewMap}
          />
        </div>
        <div style={{ position: 'relative', zIndex: '1' }}>
          <AreaInfo />
        </div>
      </PageWrapper>
    );
  }
}

Homes.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  area: PropTypes.object,
  page: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

Homes.defaultProps = {
  area: undefined,
};

export default withData(
  {
    area: true,
    page: 'homes',
    builder: true,
    homes: true,
  },
  {
    required: {
      page: true,
      builder: true,
      homes: true,
    },
    ifMissing404: true,
  },
)(Homes);



// WEBPACK FOOTER //
// ./src/pages/Homes/index.js